<template>
  <div class="module_cont">
    <div class="modulesbox">
      <div class="content" v-if="allControlData">
        <div class="title">
          <div class="text">
            {{ allControlData.result.name }}
          </div>
          <div class="module-switch-box" :class="!roleBtnCodes.includes('AIControl_module_switch') &&
            'module-switch-box-disabled'
            ">
            <div class="module-switch" @click="openmodule1(allControlData.result.runbtn)">
              <img src="../../../assets/btn(6).png" alt="" v-if="allControlData.result.runbtn == true" />
              <img src="../../../assets/btn3.png" alt="" v-if="allControlData.result.runbtn == false" />
            </div>
          </div>
        </div>
        <div>
          <div class="status_btn">
            <div class="status_box" v-if="allControlData.result.operate_status.status < 5">
              {{ allControlData.result.operate_status.des }}
              <span v-if="allControlData.result.operate_status.status < 5">
                <span class="status_color" style="color: #d43030"
                  v-if="allControlData.result.operate_status.status == 2">
                  {{ allControlData.result.operate_status.des }}</span>
                <span class="status_color" style="color: rgba(191, 128, 33, 1)"
                  v-if="allControlData.result.operate_status.status == 3">
                  {{ allControlData.result.operate_status.des }}</span>
                <span class="status_color" style="color: #498af4"
                  v-if="allControlData.result.operate_status.status == 4">
                  {{ allControlData.result.operate_status.des }}</span>
              </span>
            </div>
            <div class="mode_btn" v-if="recordlist.length > 0">
              Al Model
              <div class="mode_select">
                <el-select v-model="modevalue" placeholder="select" :disabled="selectable">
                  <el-option v-for="item in recordlist" :key="item.mode" :label="item.name" :value="item.mode"
                    @change="runBtn()" @click.native="runBtn()">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="btn_box" v-if="refresh">
              <el-button v-for="(item, index, id) in allControlData.result.pool" :key="item.id" type="primary"
                class="poolbtn" size="small" :style="cbrBtnStyle(index)"
                :disabled="!roleBtnCodes.includes('AIControl_pool_switch')" @click="cbrBtn(index, id)">{{ item.id }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Close AI Reason" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" center
      v-if="dialogVisible">
      <div>
        <div v-for="(item, index) in reasonlist" class="reasonitem" :key="index">
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="item.desc">
              {{ item.desc }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <el-input type="textarea" :rows="2" placeholder="Please enter content" v-model="textarea"
          v-if="checkList.includes('Other reasons')">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="commitclose()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
// import config from "@/utils/config";

export default {
  data() {
    return {
      show: true,
      allControlData: null,
      openIndex: null,
      textarea: null,
      reasonlist: [

      ],
      reason: null,
      checkList: [],
      dialogVisible: false,
      changeindex: null,
      ailist: null,
      recordlist: [],
      modevalue: "0",
      refresh: true,
      roleBtnCodes: [],
    };
  },
  components: {},
  watch: {
    "$store.state.theme"(newVal, oldVal) {
      this.refresh = false;
      this.cbrBtnStyle();
    },
    "$store.state.roleBtnCodes": {
      handler(val) {
        this.roleBtnCodes = val || [];
      },
      immediate: true,
    },
  },
  mounted() {
    this.openIndex = this.$route.query.index;
    this.openmodule = this.$route.query.module;
    this.getControlData(this.openIndex);
    this.getaimode();
    // setTimeout(this.getaimode(), 0);
    this.getrecordlist();
    this.getmodulesmode();
    this.timer = window.setInterval(() => {
      setTimeout(this.getControlData(this.openIndex), 0);
      setTimeout(this.getaimode(), 0);
    }, 600000);
  },
  methods: {
    async getrecordlist(module) {
      const { data: res } = await this.$http.get(
        "/modules/mode/record/list",
        {
          params: { module: this.openmodule },
        }
      );
      console.log(res.data);
      this.recordlist = res.data.data;
      this.selectable = res.data.mode_lock;

      // this.modevalue = res.data.mode
    },
    async getmodulesmode(module) {
      const { data: res } = await this.$http.get(
        "/modules/mode/record",
        {
          params: { module: this.openmodule },
        }
      );
      this.modevalue = res.data.mode;
    },
    async getaimode() {
      const { data: res } = await this.$http.get(
        "/modules/aimode/get",
        {
          params: { index: this.openIndex },
        }
      );
      // console.log(res);
      this.ailist = res.data.result;
    },

    changemodule() {

    },

    handleClose() {
      this.dialogVisible = false;
    },
    async openmodule1(index, index2) {


    },
    async getControlData(index) {
      const { data: res } = await this.$http.get("/modules/init", {
        params: { index: index },
      });
      this.allControlData = res.data;
      console.log(this.allControlData);
      this.tag = [];
      for (let a = 0; a < this.allControlData.result.table.length; a++) {
        if (this.allControlData.result.table[a].current == "-999") {
          this.allControlData.result.table[a].current = "NA";
        }
        if (this.allControlData.result.table[a].target !== "NA") {
          this.tag.push({
            id: this.allControlData.result.table[a].id,
            tag: this.allControlData.result.table[a].tag,
            target: (
              (this.allControlData.result.table[a].target[0] +
                this.allControlData.result.table[a].target[1]) /
              2
            ).toFixed(2),
            fudong: (
              (this.allControlData.result.table[a].target[1] -
                this.allControlData.result.table[a].target[0]) /
              2
            ).toFixed(2),
          });
        } else {
          this.tag.push({
            id: this.allControlData.result.table[a].id,
            tag: this.allControlData.result.table[a].tag,
            target: "-",
            fudong: "-",
          });
        }
      }
      console.log(this.allControlData);
    },
    cbrBtnStyle(index) {
      let theme = localStorage.getItem("theme")
        ? JSON.parse(localStorage.getItem("theme"))
        : "light";
      this.refresh = true;
      if (theme == "light") {
        if (this.allControlData.result.pool[index].flag == true) {
          return { backgroundColor: "#2466A8", color: "fff" };
        } else {
          return { backgroundColor: "#b8b8b8", color: "fff" };
        }
      } else {
        if (this.allControlData.result.pool[index].flag == true) {
          return { backgroundColor: "#2466A8", color: "#40E0D0" };
        } else {
          return { backgroundColor: "rgba(46, 46, 46, 1)", color: "fff" };
        }
      }
    },
    async cbrBtn(index, id) {
      console.log(111111);

      id = this.allControlData.result.pool[index].id;
      // console.log(this.inAerationData);
      // console.log(id);
      if (this.allControlData.result.pool[index].flag == true) {
        const { data: res1 } = await this.$http.post(
          "/modules/pool",
          {
            index: this.allControlData.index,
            id: id,
            flag: false,
          }
        );
        if (res1.meta.status == 403) {
          // this.getControlData(this.openIndex);
          this.getmodeltype();

          return this.$message.error(res1.meta.msg);
        }
      } else if (this.allControlData.result.pool[index].flag == false) {
        const { data: res2 } = await this.$http.post(
          "/modules/pool",
          {
            index: this.allControlData.index,
            id: id,
            flag: true,
          }
        );
        if (res2.meta.status == 403) {
          this.getmodeltype();

          return this.$message.error(res2.meta.msg);
        }
      }

      this.getControlData(this.openIndex);
    },
    async runBtn() {
      console.log(this.modevalue);
      const { data: res2 } = await this.$http.post(
        "/modules/mode/record",
        {
          module: this.allControlData.result.module,
          mode: this.modevalue,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.module_cont {
  .modulesbox {
    left: 33.8px;
    top: 113.1px;
    width: 773.7px;
    height: 145.6px;
    opacity: 1;
    border-radius: 26px; // background: rgba(255, 255, 255, 1);
    background-color: #212121FF;
    box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 650px;
      height: 145.6px;

      .title {
        display: flex;
        justify-content: space-between;
        margin-top: 28.6px;
        margin-bottom: 17px;

        .text {
          left: 83.2px;
          top: 141.7px;
          min-width: 308.1px;
          height: 37.7px;
          opacity: 1;

          font-size: 22px;
          font-weight: 400;
          letter-spacing: 0px;
          text-align: left;
          vertical-align: top;

          .eq_btn {
            font-size: 16px;
            margin-right: 20px;
          }
        }

        .module-switch-box {
          img {
            width: 40.3px;
            height: 37.66px;
            cursor: pointer;
          }
        }

        .module-switch-box-disabled {
          cursor: not-allowed;

          .module-switch {
            pointer-events: none;
          }
        }
      }

      .status_btn {
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        .status_box {
          left: 83.2px;
          top: 196.3px;
          width: 204px;
          height: 31px;
          opacity: 1;
          font-size: 18px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 30.12px;
          color: #FF6347;
          text-align: left;
          vertical-align: top;
        }

        .poolbtn {
          background: #1F2E40 !important;
          color: #40E0D0 !important;
          border: 0.64px solid #40E0D0;
        }
      }
    }
  }

  .mode_btn {
    display: flex;
    align-items: center;
    color: #40E0D0 !important;

    .mode_select {
      margin-left: 10px;
      width: 150px;
    }
  }
}
</style>
